/**
 * Escape closes the topmost overlay and only the topmost.
 *
 * The prototype registers one global handler per overlay, so a single Escape clears both the
 * delete dialog and the editor. A stack gives the precedence for free.
 */

import { useEffect } from 'react';

const stack: Array<() => void> = [];

export function useEscapeKey(active: boolean, onEscape: () => void): void {
  useEffect(() => {
    if (!active) return;
    const entry = () => onEscape();
    stack.push(entry);

    const handle = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      const top = stack[stack.length - 1];
      if (top !== entry) return;
      event.stopPropagation();
      top();
    };

    document.addEventListener('keydown', handle);
    return () => {
      document.removeEventListener('keydown', handle);
      const at = stack.indexOf(entry);
      if (at >= 0) stack.splice(at, 1);
    };
  }, [active, onEscape]);
}
